export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative pt-[72px] min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20warm%20toned%20artistic%20background%20with%20flowing%20organic%20shapes%2C%20soft%20peach%20coral%20and%20cream%20gradients%2C%20editorial%20magazine%20hero%20atmosphere%2C%20entertainment%20media%20vibe%2C%20elegant%20modern%20composition%20with%20gentle%20dramatic%20lighting%2C%20no%20realistic%20objects%2C%20pure%20artistic%20abstract%20design&width=1600&height=900&seq=hero-chigua-main&orientation=landscape"
          alt="吃瓜在线主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-5 whitespace-nowrap">
              今日吃瓜 · 实时爆料
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              吃瓜在线 — 你的娱乐八卦第一站
            </h1>

            <p className="text-lg md:text-xl text-background-50/90 font-heading mb-6">
              最新吃瓜在线，吃瓜不等待
            </p>

            <div className="space-y-3 text-background-50/80 text-sm md:text-base leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                吃瓜在线是国内领先的51国产吃瓜在线今日吃瓜内容聚合平台，每日24小时不间断追踪娱乐圈、网红圈、综艺影视等全方位八卦资讯。无论是今日吃瓜爆料最新视频还是今日吃瓜在线观看，吃瓜在线都是你最值得信赖的吃瓜伙伴。
              </p>
              <p>
                我们拥有专业编辑团队与智能算法，确保每一条今日吃瓜最新动态都经过严格核实，让你在第一时间获取最真实、最精彩、最火爆的娱乐八卦信息。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">24h</div>
                <div className="text-xs text-background-50/60 mt-1">全天候更新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">2000+</div>
                <div className="text-xs text-background-50/60 mt-1">日均内容量</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">5000万</div>
                <div className="text-xs text-background-50/60 mt-1">累计吃瓜群众</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#topics"
                onClick={(e) => handleScroll(e, '#topics')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/20 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-hashtag"></i>
                热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20art%20with%20warm%20peach%20and%20coral%20tones%2C%20abstract%20entertainment%20news%20visual%2C%20flowing%20organic%20shapes%2C%20soft%20dramatic%20lighting%2C%20modern%20elegant%20aesthetic%2C%20cinematic%20composition%2C%20clean%20minimal%20design%20with%20warm%20ambient%20glow%2C%20luxurious%20magazine%20quality&width=900&height=1100&seq=hero-visual-chigua&orientation=portrait"
                alt="吃瓜在线主题主视觉"
                className="w-full h-auto object-cover rounded-2xl"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent p-6">
                <div className="flex items-center gap-3 text-background-50 text-xs">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 实时更新</span>
                  <span className="flex items-center gap-1"><i className="ri-verified-badge-line"></i> 内容核实</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}